


































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as _ from 'lodash';
import API from '@/api'

@Component({
  components: {
  },
})
export default class App extends Vue {
  public yen: number = 0
  public api: API 
  public rows: any[] = []
  public value: string = '';
  public options = ['hour', 'day', 'month']
  public times = [1, 24, 720];
  public option = 0

  constructor() {
    super();
    this.api = new API();
  }

  public async created() {
    const data = await this.api.getRate();
    this.yen = Number(data!.open);

    this.rows = await this.api.getAwsCost('/api/aws/ec2');
  }

  public ysort(o: any) {
    return Number(o.price.USD);
  }

  public priceFilter(v: any) {
    const price = Number(v.price.USD) * Number(this.yen) * this.times[this.option]
    return price < Number(this.value);
  }

  get filterRows () {
    if (!this.value) {
      return _.sortBy(this.rows, [this.ysort]);
    }
    return _.sortBy(this.rows.filter(this.priceFilter), [this.ysort]);
  }

  public filter(e: any) {
    this.value = e.target.value
  }

  public filterPrice(e:any) {
    this.option = e.target.value
  }

  public money(type: string, price: string) {
    let mprice = 0;
    switch (type) {
      case 'hour':
        mprice = (this.yen * Number(price))
        break;
      case 'day':
        mprice= (this.yen * Number(price) * 24)
        break;
      case 'month':
        mprice = (this.yen * Number(price) * 24 * 30)
        break;
      default:
        break;
    }
    return mprice.toFixed(2)
  }
}
